import { isRouteErrorResponse, useNavigate, useRouteError } from "react-router";
import { FailureCard } from "@/shared/components/FailureCard";
import { describeError } from "@/shared/api/errors";
import { NotFoundPage } from "./NotFoundPage";

/** Router error element: loader, lazy-import and render errors land here with a way forward. */
export function RouteErrorPage() {
  const error = useRouteError();
  const navigate = useNavigate();
  if (isRouteErrorResponse(error) && error.status === 404) return <NotFoundPage />;
  const { title, detail } = describeError(error);
  const stack = error instanceof Error ? error.stack : null;
  return (
    <div className="p-6">
      <FailureCard
        title={title === "Something went wrong" ? "This page could not be shown" : title}
        description="Reloading usually fixes it. If it keeps happening, share the technical details with support."
        onRetry={() => void navigate(0)}
        retryLabel="Reload"
        details={[detail, stack].filter(Boolean).join("\n\n") || null}
      />
    </div>
  );
}
